import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Users, BarChart3, Settings, Download, Inbox, Megaphone, GitBranch, SlidersHorizontal } from 'lucide-react';

const Sidebar = () => {
  const location = useLocation();

  const menuItems = [
    { path: '/', icon: Home, label: 'Dashboard' },
    { path: '/influencers', icon: Users, label: 'Influencers' },
    { path: '/heepsy', icon: Download, label: 'Heepsy Scraper' },
    { path: '/review', icon: Inbox, label: 'Review Queue' },
    { path: '/campaigns', icon: Megaphone, label: 'Campaigns' },
    { path: '/pipeline', icon: GitBranch, label: 'Pipeline' },
    { path: '/admin-settings', icon: SlidersHorizontal, label: 'Settings' },
    { path: '/analytics', icon: BarChart3, label: 'Analytics' },
    { path: '/settings', icon: Settings, label: 'Settings' },
  ];

  return (
    <div className="bg-gray-900 text-white w-64 flex-shrink-0">
      <div className="flex items-center justify-center h-20 border-b border-gray-800">
        <h1 className="text-2xl font-bold">🎯 Influencer Hub</h1>
      </div>
      <nav className="mt-8">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center px-6 py-3 text-gray-300 hover:bg-gray-800 hover:text-white transition-colors ${
                isActive ? 'bg-gray-800 text-white border-l-4 border-blue-500' : ''
              }`}
            >
              <Icon className="w-5 h-5 mr-3" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default Sidebar;
